import { render, staticRenderFns } from "./FpuiInputCheckbox.vue?vue&type=template&id=5d8bcc51&lang=pug&"
import script from "./FpuiInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./FpuiInputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FpuiInputCheckbox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports